import { IonIcon } from "@ionic/react";
import { videocamOutline, megaphoneOutline, micOutline } from "ionicons/icons";

// bulb,
//   phonePortraitOutline,
//   archive,
//   build,

export const listService = [
  {
    color: " #D94F26",
    icon: <IonIcon icon={videocamOutline} />,
    title: "Publicidad Impactante",
    desc: "Sumérgete en campañas visuales que no solo capturan la atención, sino que dejan una impresión duradera en la mente de tu audiencia. Desde medios digitales hasta la vía pública, creamos experiencias visuales que resaltan.",
  },
  {
    color: " #1D7435",
    icon: <IonIcon icon={megaphoneOutline} />,
    title: "Perifoneo y Volanteo Efectivo",
    desc: "Llevamos tu mensaje más allá de las pantallas, directamente a donde está tu audiencia. Con estrategias de perifoneo y volanteo precisas, aseguramos que tu marca esté presente en cada rincón relevante.",
  },
  {
    color: " #ffb700",
    icon: <IonIcon icon={micOutline} />,
    title: "Grabación de Piezas Publicitarias de Alta Calidad",
    desc: "Confía en nuestro equipo de expertos creativos y técnicos para dar vida a tu mensaje a través de piezas auditivas excepcionales. Desde comerciales hasta mensajes corporativos, garantizamos calidad que se escucha.",
  },
];
